import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '../../ui/dialog';
import { cn } from '../../../lib/utils';

export function ReferenceImage({ 
  imageUrl, 
  isLandscape, 
  isDragHovering, 
  isOverlayActive,
  isImageOpen,
  setIsImageOpen,
  refImageRef,
  hideReferenceImage
}) {
  if (!imageUrl || hideReferenceImage) return null;

  return (
    <>
      {/* Floating Reference Image - Top Right */}
      {!isImageOpen && (
        <div 
          ref={refImageRef}
          className={cn(
            "fixed top-2 right-2 sm:right-4 z-[60] cursor-pointer rounded-lg overflow-hidden border-2 border-border hover:border-primary/50 transition-all duration-200 shadow-lg",
            isLandscape ? "w-[50px] h-[50px]" : "w-[70px] h-[70px] sm:w-[90px] sm:h-[90px] lg:w-[110px] lg:h-[110px]",
            isDragHovering && "ring-4 ring-primary scale-110 border-primary",
            isOverlayActive && "opacity-0 pointer-events-none"
          )}
          onClick={() => setIsImageOpen(true)}
          data-testid="reference-image-thumbnail"
        >
          <img 
            src={imageUrl} 
            alt="Reference" 
            className="w-full h-full object-cover"
            draggable={false}
          />
        </div>
      )}
      
      {/* Fullscreen Reference Image Dialog */}
      <Dialog open={isImageOpen} onOpenChange={setIsImageOpen}>
        <DialogContent 
          className="max-w-4xl w-[95vw] p-0 bg-transparent border-none [&>button]:hidden cursor-pointer" 
          hideCloseButton
          onClick={() => setIsImageOpen(false)}
        >
          <DialogTitle className="sr-only">Reference Image</DialogTitle>
          <div onClick={() => setIsImageOpen(false)}>
            <img 
              src={imageUrl} 
              alt="Full reference" 
              className="w-full h-auto max-h-[85vh] object-contain rounded-xl shadow-2xl pointer-events-none"
              draggable={false}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
